import { render } from "./UiButton.vue?vue&type=template&id=39bb5f96&ts=true"
import script from "./UiButton.vue?vue&type=script&lang=ts"
export * from "./UiButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__